import { type InferType, boolean, date, object, string } from "yup";

const settingValueMetaDataSchema = object({
  coachingState: string(),
  needLastCer: boolean(),
  convocation: boolean(),
});

export const settingValueMasterSchema = object({
  value: string().required(),
  label: string().required(),
  active: boolean().required(),
  createByDefault: boolean().required(),
  searchByDefault: boolean().required(),
  isAutoTask: boolean().required(),
  metadata: settingValueMetaDataSchema.optional(),
  deactivationDate: date(),
  icon: string().optional(),
  group: string(),
  isEditable: boolean().required(),
});

export type SettingValueMasterResolver = InferType<typeof settingValueMasterSchema>;
